import { FC, ReactNode, useEffect } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { updateOpen, updateContent } from '../store/dialog';
import { RootState } from '../store';

// hooks
import { useLayout } from '../hooks/useLayout';
import { useCancelProfileUpdate } from '../hooks/useCancelProfileUpdate';

// component
import { GlobalNavigation } from './globalNavigation';
import { HasEmptyFieldsDialog } from './hasEmptyFieldsDialog';
// assets
import style from '../assets/style/layout/layout.module.scss';

// function component
type Props = {
  children: ReactNode;
  customHeader?: ReactNode;
  customFooter?: ReactNode;
};
export const Layout: FC<Props> = ({ children, customHeader, customFooter }) => {
  const dispatch = useDispatch();

  const { isUserRegistered, hasEmptyFields } = useSelector((state: RootState) => state.user);
  const { isAccepting } = useSelector((state: RootState) => state.survey);

  useEffect(() => {
    // ページがプロフィール配下になっているかどうか
    const isProfile = window.location.pathname.match(/profile/g);

    // 誘導ダイアログ
    // ユーザー登録済みで、データに欠損があり、プロフィールページ以外の場合
    if (isUserRegistered && hasEmptyFields && !isProfile) {
      dispatch(updateOpen(true));
      dispatch(updateContent(<HasEmptyFieldsDialog />));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserRegistered, hasEmptyFields]);

  useLayout();
  useCancelProfileUpdate();

  // ナビゲーションの表示条件
  const shouldShowNavigation = !isUserRegistered || !hasEmptyFields;

  return (
    <div
      className={[style.layout, !customFooter ? style.hasGlobalNavigation : undefined].join(' ')}
      aria-busy={isUserRegistered === null || isAccepting === null ? 'true' : undefined}
    >
      <div className={style.header}>{customHeader}</div>
      <main className={style.body}>{children}</main>
      {shouldShowNavigation && (
        <div className={`style.footer`}>{customFooter || <GlobalNavigation />}</div>
      )}
    </div>
  );
};
